import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import { ShoppingCart, Instagram } from 'lucide-react';

const WHATSAPP_NUMBER = '5573991923111';
const INSTAGRAM_HANDLE = 'petiscariacamamu';

const Header = () => {
  const navigate = useNavigate();
  const { getCartCount, setIsCartOpen } = useCart();
  const cartCount = getCartCount();

  return (
    <header className="sticky top-0 z-40 bg-[#FAF8F5]/95 backdrop-blur-md border-b border-[#F3E8E3]">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-2">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          data-testid="header-logo-button"
        >
          <img
            src="/images/logo.png"
            alt="Petiscaria Camamu"
            className="h-14 w-14 object-contain"
            data-testid="header-logo"
          />
          <div className="hidden md:block text-left">
            <h1
              className="text-xl font-bold text-[#7F1D1D] leading-tight"
              style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
            >
              Petiscaria Camamu
            </h1>
            <p
              className="text-xs text-[#5C4247]"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Petiscos artesanais
            </p>
          </div>
        </button>

        <div className="flex items-center gap-2">
          {/* WhatsApp */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Vim pelo site e gostaria de fazer um pedido.')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center h-10 w-10 sm:w-auto sm:px-4 rounded-full bg-[#25D366] hover:bg-[#1ebd5a] text-white transition-all shadow-sm hover:shadow-md"
            aria-label="WhatsApp"
            data-testid="header-whatsapp-button"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
            <span className="hidden sm:inline ml-2 font-semibold text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>WhatsApp</span>
          </a>

          {/* Instagram */}
          <a
            href={`https://instagram.com/${INSTAGRAM_HANDLE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center h-10 w-10 sm:w-auto sm:px-4 rounded-full text-white transition-all shadow-sm hover:shadow-md"
            style={{
              background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
            }}
            aria-label="Instagram"
            data-testid="header-instagram-button"
          >
            <Instagram className="h-5 w-5" />
            <span className="hidden sm:inline ml-2 font-semibold text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>Instagram</span>
          </a>

          {/* Cart */}
          <Button
            onClick={() => setIsCartOpen(true)}
            variant="outline"
            className="relative border-[#7F1D1D] text-[#7F1D1D] hover:bg-[#7F1D1D] hover:text-white rounded-full h-10 px-3 sm:px-4"
            data-testid="header-cart-button"
          >
            <ShoppingCart className="h-5 w-5" />
            <span className="ml-2 hidden lg:inline font-semibold">Carrinho</span>
            {cartCount > 0 && (
              <span
                className="absolute -top-2 -right-2 bg-[#EA580C] text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center"
                style={{ fontFamily: 'Outfit, sans-serif' }}
                data-testid="header-cart-count"
              >
                {cartCount}
              </span>
            )}
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
